module.exports = __webpack_public_path__ + "img/catch02.df0a921e.png";